// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__dNJf8","title":"styles_title__PtWtz","keyPIXBox":"styles_keyPIXBox__FOjSL","qrcodeBox":"styles_qrcodeBox__a5FZy"};